import axios from 'axios';
import apiPath from 'apiPath';

const isFieldTransaction = transaction => transaction.DepartmentGroupId === '32899';
const isTuitionTransaction = transaction => transaction.DepartmentGroupId === '0' || transaction.DepartmentGroupId === '33532';
const isInsuranceTransaction = transaction => transaction.DepartmentGroupId === '33411';
const isCredit = transaction => transaction.DepartmentType.substr(0,1) === 'C';
const isDebit = transaction => transaction.DepartmentType.substr(0,1) === 'D';

const totalTransactions = transactions => transactions.map(transaction => parseFloat(transaction.Amount)).reduce((acc, val) => acc + val, 0);

const calculateBalance = (booking, kickSession) => {
	return axios.get(apiPath+'/transactions', {withCredentials: true}).then(result => {
		let transactions = [];
		result.data.forEach(transaction => {
			if (!transactions.find(t => t.id === transaction.id)) transactions.push(transaction);
		});

		const fieldTransactions = transactions.filter(t => isFieldTransaction(t) && isDebit(t));
		const fieldPayments = transactions.filter(t => isFieldTransaction(t) && isCredit(t));
		const tuitionTransactions = transactions.filter(t => isTuitionTransaction(t) && isDebit(t));
		const tuitionPayments = transactions.filter(t => isTuitionTransaction(t) && isCredit(t));
		const insuranceTransactions = transactions.filter(t => isInsuranceTransaction(t) && isDebit(t));
		const insurancePayments = transactions.filter(t => isInsuranceTransaction(t) && isCredit(t));

		return {
			transactions: transactions,

			fieldTransactions: fieldTransactions,
			fieldChargeTotal: totalTransactions(fieldTransactions),
			fieldPayments: fieldPayments,
			fieldCreditTotal: totalTransactions(fieldPayments),
			
			tuitionTransactions: tuitionTransactions,
			tuitionChargeTotal: totalTransactions(tuitionTransactions),
			tuitionPayments: tuitionPayments,
			tuitionCreditTotal: totalTransactions(tuitionPayments),

			insuranceTransactions: insuranceTransactions,
			insuranceChargeTotal: totalTransactions(insuranceTransactions),
			insurancePayments: insurancePayments,
			insuranceCreditTotal: totalTransactions(insurancePayments)
		};
	}).catch(error => {
		console.error(error);
		if (error.response.status === 403) kickSession();
		if (error.response.status === 401 || error.response.status === 405) kickSession('Your session has expired');
	});
}
module.exports = calculateBalance;



// WEBPACK FOOTER //
// ./portal-components/Portal/FieldPrograms/calculateBalance.js